import React, { useEffect, useState } from 'react';

import './EmployeeHistory.css';
import axios from 'axios';

const InfoTable = () => {

  const [data, setData] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [workHistory, setWorkHistory] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showWorkHistoryModal, setShowWorkHistoryModal] = useState(false);


  useEffect(() => {
    const fetchEmployeeTasks = async (empID) => {
      try {
        // const response = await axios.get(`http://localhost:8082/api/admin/employee_tasks/${empID}`);
        const response = await axios.get(`https://hfstaff.com/api/admin/employee_tasks/${empID}`);
        setData(response.data);
        setLoading(false);
      } catch (error) {
        setError('Error fetching employee tasks');
        setLoading(false);
      }
    };

    fetchEmployeeTasks(1);
  }, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        // const response = await axios.get('http://localhost:8082/api/admin/employees');
        const response = await axios.get('https://hfstaff.com/api/admin/employees');
        setEmployees(response.data);
        setLoading(false);
      } catch (error) {
        setError('Error fetching employees');
        setLoading(false);
      }
    };

    fetchEmployees();
  }, []);

  const handleWorkHistoryClick = async (empID) => {
    //console.log("employee Id is");
    //console.log(empID);
    const employee = employees.find(emp => emp.emp_id === empID);
    setSelectedEmployee(employee);
    const empWorkHistory = data.filter(work => work.emp_id === empID);
    setWorkHistory(empWorkHistory);
    setShowWorkHistoryModal(true);
    //console.log("clicked");
    //console.log(empWorkHistory);
  };

  const handleCloseWorkHistoryModal = () => {
    setShowWorkHistoryModal(false);
    setSelectedEmployee(null);
    setWorkHistory([]);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="info-table-container">
      {showWorkHistoryModal && selectedEmployee && (
        <div className="employee-history-modal">
          <div className="employee-history-modal-content">
            <span className="close" onClick={handleCloseWorkHistoryModal}>&times;</span>
            <h2>Work History for {selectedEmployee.p_name}</h2>
            <div className="work-history">
              <table>
                <thead>
                  <tr>
                    <th>Task Name</th>
                    <th>Total Time</th>
                    <th>Task Description</th>
                  </tr>
                </thead>
                <tbody>
                  {workHistory.map((work, index) => (
                    <tr key={index}>
                      <td>{work.task_name}</td>
                      <td>{work.total_time}</td>
                      <td>{work.task_desc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      <div className="employee-list">
        <table>
          <thead>
            <tr>
              <th>Photo</th>
              <th>Employee ID</th>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {employees.map(employee => (
              <tr className="employee-item" key={employee.emp_id}>
                <td><img src={employee.p_img} alt={employee.p_name} className="employee-photo" /></td>
                <td className="employee-id">{employee.emp_sap_id}</td>
                <td className="employee-name">{employee.p_name}</td>
                <button className="history-btn" onClick={() => handleWorkHistoryClick(employee.emp_id)}>Work History</button>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InfoTable;
